import { clsx } from 'clsx'
import { LuSearch } from 'react-icons/lu'

import { ModalBase } from '@/lib/core/components/Modal/ModalBase'

import styles from './CommandPalette.module.css'
import { useCommandPalette } from './useCommandPalette'

export const CommandPalette = () => {
  const {
    close,
    handleInputKeyDown,
    highlightedIndex,
    inputRef,
    isOpen,
    navigateTo,
    query,
    results,
    setHighlightedIndex,
    setQuery,
  } = useCommandPalette()

  return (
    <ModalBase
      isActive={isOpen}
      onEscape={close}
      dataTestId="command-palette"
      aria-label="Command palette"
    >
      {isOpen && (
        <div className={styles.palette}>
          <div className={styles.inputRow}>
            <LuSearch className={styles.searchIcon} size="20" aria-hidden />
            <input
              ref={inputRef}
              className={styles.input}
              type="text"
              value={query}
              placeholder="Search pages..."
              aria-label="Search pages"
              data-testid="command-palette-input"
              onChange={(event) => setQuery(event.target.value)}
              onKeyDown={handleInputKeyDown}
            />
          </div>
          {results.length === 0 ? (
            <p className={styles.empty} data-testid="command-palette-empty">
              No pages found
            </p>
          ) : (
            <ul className={styles.results}>
              {results.map((item, index) => (
                <li key={item.id}>
                  <button
                    type="button"
                    className={clsx(
                      styles.result,
                      index === highlightedIndex && styles.highlighted,
                    )}
                    aria-current={index === highlightedIndex || undefined}
                    data-testid={`command-palette-item-${item.id}`}
                    onMouseEnter={() => setHighlightedIndex(index)}
                    onClick={() => navigateTo(item)}
                  >
                    <item.Icon className={styles.resultIcon} size="20" aria-hidden />
                    <span>{item.label}</span>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </ModalBase>
  )
}
